var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "magic-zoom" } }, [
    _c(
      "div",
      {
        class: { "video-active": _vm.video == true },
        attrs: { itemscope: "", itemtype: "http://schema.org/Thing" }
      },
      [
        _c(
          "div",
          {
            staticClass: "ItemImgWrap justify-content-center",
            class: {
              "more-images":
                _vm.visibleImages.length > 1 || _vm.findVideo !== ""
            }
          },
          [
            _vm.findVideo
              ? [
                  _vm.video
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-videoplay d-lg-none",
                          on: { click: _vm.videoFalse }
                        },
                        [_c("i", { staticClass: "fa fa-rotate-left" })]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn btn-videoplay d-lg-none",
                          on: { click: _vm.playVideo }
                        },
                        [_c("i", { staticClass: "fa fa-youtube-play" })]
                      )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.proofMassband && !_vm.video
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-massband",
                    on: { click: _vm.showMassband }
                  },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        src:
                          "https://cdn02.plentymarkets.com/5rtbqcd0flq3/frontend/Webseite/SingleItem/Massband.png",
                        alt: _vm.$translate("Snaply5::Template.singleMassband"),
                        title: _vm.$translate(
                          "Snaply5::Template.singleMassband"
                        )
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleImages.length > 1 || _vm.findVideo !== ""
              ? [
                  _vm.anzahlBilderAndStuff >= 4
                    ? _c(
                        "div",
                        { staticClass: "magic-more-images d-none d-lg-block" },
                        [
                          _vm.anzahlBilderAndStuff > 4
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "fa-rotate-270 flipiconZoom mt-4",
                                  on: { click: _vm.slidePrev }
                                },
                                [
                                  _c("i", {
                                    staticClass: "snaply-chevron blue"
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "hooper",
                            {
                              ref: "carousel",
                              staticClass: "d-none d-lg-block",
                              attrs: {
                                vertical: true,
                                infiniteScroll: false,
                                itemsToShow: 4,
                                trimWhiteSpace: true
                              }
                            },
                            [
                              _vm.findVideo !== ""
                                ? _c("slide", [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "border videoplay-icon mz-thumb",
                                        on: {
                                          click: function($event) {
                                            return _vm.playVideo()
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-play-circle-o"
                                        })
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.visibleImages, function(
                                imagePreview,
                                index
                              ) {
                                return _c("slide", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "border",
                                      attrs: {
                                        href: imagePreview.url,
                                        rel: "zoom-id:ItemImgZoom",
                                        "data-image": imagePreview.urlMiddle
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.videoFalse()
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          "data-src": imagePreview.url,
                                          src: imagePreview.urlPreview,
                                          alt:
                                            _vm.magiczoom.texts.name1 +
                                            "-" +
                                            index,
                                          title:
                                            _vm.magiczoom.texts.name1 +
                                            "-" +
                                            index
                                        }
                                      })
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.anzahlBilderAndStuff > 4
                            ? _c(
                                "div",
                                {
                                  staticClass: "fa-rotate-90 mt-4",
                                  on: { click: _vm.slideNext }
                                },
                                [
                                  _c("i", {
                                    staticClass: "snaply-chevron blue"
                                  })
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "magic-more-images d-none d-lg-block" },
                        [
                          _vm.findVideo !== ""
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "border videoplay-icon mb-2 border mz-thumb",
                                  on: {
                                    click: function($event) {
                                      return _vm.playVideo()
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-play-circle-o"
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.visibleImages, function(
                            imagePreview,
                            index
                          ) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "mb-2 border",
                                  attrs: {
                                    href: imagePreview.url,
                                    rel: "zoom-id:ItemImgZoom",
                                    "data-image": imagePreview.urlMiddle
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.videoFalse()
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      "data-src": imagePreview.url,
                                      src: imagePreview.urlPreview,
                                      alt:
                                        _vm.magiczoom.texts.name1 + "-" + index,
                                      title:
                                        _vm.magiczoom.texts.name1 + "-" + index
                                    }
                                  })
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                class: { "my-d-block": _vm.video == true },
                attrs: { href: "#" }
              },
              [
                _vm.video == true
                  ? _c(
                      "video",
                      { attrs: { width: "100%", controls: "", autoplay: "" } },
                      [
                        _c("source", {
                          attrs: { src: _vm.findVideo, type: "video/mp4" }
                        }),
                        _vm._v(
                          "\n                  Your browser does not support the video tag.\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "MagicZoomPlus flex-fill d-flex align-items-start justify-content-center",
                class: { "my-d-none": _vm.video == true },
                attrs: {
                  href: _vm._f("itemImage")(
                    _vm._f("itemImages")(_vm.visibleImageSet, "url")
                  ),
                  id: "ItemImgZoom",
                  "data-mobile-options":
                    "zoomMode:off; lazyZoom: true; textTouchZoomHint:" +
                    _vm.$translate("Snaply5::Template.singleZoomHint") +
                    "; textClickZoomHint: " +
                    _vm.$translate("Snaply5::Template.singleZoomHint2") +
                    "; textExpandHint: " +
                    _vm.$translate("Snaply5::Template.singleZoomHint"),
                  "data-options":
                    "lazyZoom: true;cssClass: white-bg; zoom-height:500px; textHoverZoomHint:" +
                    _vm.$translate("Snaply5::Template.singleZoomHint3") +
                    "; textExpandHint:" +
                    _vm.$translate("Snaply5::Template.singleZoomHint3") +
                    "; zoomPosition: #zoom-placeholder;"
                }
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: _vm._f("itemImage")(
                      _vm._f("itemImages")(_vm.visibleImageSet, "urlMiddle")
                    ),
                    itemprop: "image",
                    alt: _vm.magiczoom.texts.name1,
                    title: _vm.magiczoom.texts.name1
                  }
                })
              ]
            )
          ],
          2
        ),
        _vm._v(" "),
        _vm.dotsCount > 1
          ? _c("div", {
              staticClass: "zoom-navigation-dots d-lg-none",
              class: { "d-none": _vm.video == true }
            })
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }